import React, { useState, useEffect } from 'react';
import {
  isItUndefined,
  getAlgoliaDatasetValue,
  getLanguage,
  correctInternalLink,
  createFilterData,
  marketoOptions as options,
  getAlgoliaIndex,
  unixToDate,
  unixToDateString,
  correctUrlFormatForRouting
} from '../../util/DataUtil';

const PressReleasesLatest = ({ children, lang, sizeOfScreen }) => {
  const [showMore, setShowMore] = useState([]);
  const [facetFilters, setFacetFilters] = useState([]);
  const [query, setQuery] = useState([]);
  const [page, setPage] = useState(0);

  let hitsPerPage =
    isItUndefined(children?.field_number_of_press_releases) > 0
      ? isItUndefined(children?.field_number_of_press_releases)
      : '3';
  let lng = lang;
  let facetFiltersArray = [];
  let lngArray = [];

  useEffect(() => {
    if (!lng) {
      return;
    }

    fetchAlgoliaData();
  }, []);

  const fetchAlgoliaData = () => {
    let url = createFilterData(
      lngArray,
      facetFiltersArray,
      facetFilters,
      query,
      hitsPerPage,
      page,
      lng,
      getAlgoliaDatasetValue(3) + getAlgoliaIndex()
    );

    const fetchAlgolia = async () => {
      await fetch(url, options)
        .then((response) => response.json())
        .then((newResponse) => {
          setShowMore(newResponse.hits);
        });
    };
    fetchAlgolia();
  };

  const renderPressReleases = (data) => {
    if (!data || data.length === 0) {
      return [];
    }

    const result = [];
    let itemsPerRow = 3;

    if (sizeOfScreen >= 1025) {
      for (let i = 0; i < data.length; i += itemsPerRow) {
        const rowItems = [];
        for (let j = i; j < i + itemsPerRow; j++) {
          rowItems.push(
            <a href={correctUrlFormatForRouting(data[j]?.url)?.url} className="result-item" key={j}>
              {/* { data[j]?.title && <div className="date">{data[j].date}</div> } */}
              {data[j]?.title && (
                <div className="date">{unixToDateString(data[j]?.date)}</div>
              )}
              <div className="title">{data[j]?.title}</div>
              <div className="tag">{data[j]?.category_name}</div>
            </a>
          );
        }

        result.push(
          <div className="row" key={i}>
            {rowItems}
          </div>
        );
      }
    } else {
      return data.map((obj, index) => {
        return (
          <div className="row">
            <a href={obj?.url} className="result-item" key={index}>
              {/* { obj?.title && <div className="date">02/02/2023</div> } */}
              {obj?.title && (
                <div className="date">{unixToDateString(obj?.date)}</div>
              )}
              <div className="title">{obj?.title}</div>
              <div className="tag">{obj?.category_name}</div>
            </a>
          </div>
        );
      });
    }

    return result;
  };

  return (
    <div id={'press-releases-latest'} className={'press-releases-latest'}>
      <div className="inner-container">
        <div className="top">
          <p className="title">
            {isItUndefined(children?.field_press_releases_title)}
          </p>
          <a
            className="link"
            href={correctInternalLink(
              isItUndefined(children?.field_view_all_press_releases_li, 'uri')
            )}
          >
            {isItUndefined(children?.field_view_all_press_releases_li, 'title')}
            {isItUndefined(
              children?.field_view_all_press_releases_li,
              'title'
            ) && <img alt="arrow" src="/images/more-arrow.svg" />}
          </a>
        </div>
        <hr />
        <div className="press-releases-wrapper">
          {renderPressReleases(showMore)}
        </div>
      </div>
    </div>
  );
};

export default PressReleasesLatest;
